import React from "react";
import Layout from "../../../components/layout/Layout";
import I18n from "../../../i18n";
import { ArrayUtil, DateUtil, isAlive } from "../../../util";
import { ContainerLoading, PreloadDiv } from "../../../components/loading/PersistGateLoading";
import ReportAction from "../../../actions/ReportAction";
import { StressGeneric } from "./index";
import { StressTestSupportGraph } from "../../../constants/supportGraph";
import { GraphDataMaker } from "../../../util/helper/graph";

export default (props)=><StressGeneric
	typeKey={StressTestSupportGraph.StressLevel}
	subHeader={I18n.t("stress_level_label")}
	fetchMain={ReportAction.fetchStressLevel}
	mainReadKey = 'stress_levels'
	getAutoSelectItem={(items)=>{
		const level = Math.max(0, items.findIndex((v)=>v>0));
		return {
			level, 
			item: GraphDataMaker.stressLevelToLabel(level, false)
		};
	}}
	mainSelectToFilterValue={(typeKey, value)=>{
		return value;
	}}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressByLevel.js